import { useTranslation } from 'react-i18next';

import { Invoice } from 'lane-shared/domains/billingPayments/types';
import {
  useMarkInvoiceAsBilledPermission,
  useSrInvoiceBilledStatusEnabled,
} from 'react-hooks';
import { canMarkInvoiceAsBilled } from 'domains/billingAndPayments/invoiceBilling/markInvoiceAsBilledEligibility';
import { PageHeaderActionButton } from 'components/layout/PageHeader';

import { confirmAndMarkAsBilled } from './confirmAndMarkAsBilled';
import { useMarkInvoiceAsBilled } from './useMarkInvoiceAsBilled';

export function useMarkAsBilledActionButtons(
  invoice: Invoice,
  channelId: string
): PageHeaderActionButton[] {
  const { t } = useTranslation();
  const isBilledStatusEnabled = useSrInvoiceBilledStatusEnabled();
  const hasPermission = useMarkInvoiceAsBilledPermission(channelId);
  const { markAsBilled, isLoading } = useMarkInvoiceAsBilled();
  const { isVisible, isEnabled } = canMarkInvoiceAsBilled({
    status: invoice.status,
    invoiceDate: invoice.invoiceDate,
    hasPermission,
  });

  if (!isBilledStatusEnabled || !isVisible) return [];

  return [
    {
      label: t('abp.actions.markAsBilled'),
      type: 'secondary',
      onClick: () => confirmAndMarkAsBilled({ invoice, markAsBilled, t }),
      disabled: !isEnabled,
      loading: isLoading,
      tooltip: isEnabled
        ? undefined
        : t('abp.invoice.markAsBilledNotYetAvailable'),
    },
  ];
}
